import { BUSINESS_HOURS } from "../constants/business-hours";

export function getCookie(name: any) {
  const cookieName = `${name}=`;
  let cookies = document.cookie.split("; ");

  for (let i = 0; i < cookies.length; i++) {
    if (cookies[i].startsWith(cookieName)) {
      return cookies[i].substring(cookieName.length);
    }
  }

  return null;
}

export function setCookie(name: any, value: any, days?: any) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export function eraseCookie(name: any, path = "/", domain = "") {
  let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  document.cookie = cookieString;
}

export const SLOT_MINUTES = 30;

export function ceilToNextSlot(date: Date) {
  const d = new Date(date);
  const minutes = d.getMinutes();
  const remainder = minutes % SLOT_MINUTES;

  if (remainder !== 0) {
    d.setMinutes(minutes + (SLOT_MINUTES - remainder), 0, 0);
  } else {
    d.setSeconds(0, 0);
  }
  return d;
}

export const isToday = (d: Date) => {
  const now = new Date();
  return (
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  );
};

// Returns the business end time for a given date (Saturday = 17, others = 19)
export const getBusinessEndTime = (d: Date) => {
  const isSaturday = d.getDay() === 6;
  return isSaturday ? BUSINESS_HOURS.SATURDAY_END_TIME : BUSINESS_HOURS.END_TIME;
};

export const isOutsideBusinessHours = (d: Date) => {
  const h = d.getHours();
  const endTime = getBusinessEndTime(d);
  return h < BUSINESS_HOURS.START_TIME || h >= endTime + 1;
};

export const moveToNextBusinessDay = (d?: Date) => {
  const next = d ? new Date(d) : new Date();
  next.setDate(next.getDate() + 1);
  next.setHours(BUSINESS_HOURS.START_TIME, 0, 0, 0);
  return next;
};

export const roundToNextSlot = (date: Date) => {
  const SLOT_MINUTES = 30;
  const d = new Date(date);
  const minutes = d.getMinutes();
  const remainder = minutes % SLOT_MINUTES;

  if (remainder !== 0) {
    d.setMinutes(minutes + (SLOT_MINUTES - remainder), 0, 0);
  } else {
    d.setSeconds(0, 0);
  }
  return d;
};

//const REF_TTL_MS = 5 * 60 * 1000; // 5 minutes (test)
const REF_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export const getStoredRef = (): string | null => {
  const ref = localStorage.getItem("ref");
  const ts = localStorage.getItem("ref_ts");
  if (!ref) return null;
  if (ts && Date.now() - Number(ts) > REF_TTL_MS) {
    localStorage.removeItem("ref");
    localStorage.removeItem("ref_ts");
    return null;
  }
  return ref;
};

export const clearStoredRef = () => {
  localStorage.removeItem("ref");
  localStorage.removeItem("ref_ts");
};

export const getTodayMinSlot = () => {
  const now = new Date();
  const result = new Date(now);

  // If exactly on the hour (e.g. 14:00) → that hour is the minimum slot
  // Otherwise (e.g. 14:05) → next hour is the minimum slot
  if (now.getMinutes() === 0 && now.getSeconds() === 0) {
    result.setMinutes(0, 0, 0);
  } else {
    result.setHours(now.getHours() + 1, 0, 0, 0);
  }

  // Clamp to business start
  if (result.getHours() < BUSINESS_HOURS.START_TIME) {
    result.setHours(BUSINESS_HOURS.START_TIME, 0, 0, 0);
  }

  return result;
};
